import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PathRoutes } from 'src/const/Routes/PathRoutes';
import useAppSelector from 'src/hooks/Redux/useAppSelector';
import { selectTribeDetails } from 'src/redux/slices/loggedUserSlice';
import { CircleItem } from './CircleItem/CircleItem';
import styles from './Circles.module.scss';

export const Circles = ({
  variant = 'vertical',
}: {
  variant?: 'vertical' | 'horizontal';
}) => {
  const [selectedCircle, setSelectedCircle] = useState<string | null>(null);
  const getTribeDetails = useAppSelector(selectTribeDetails);
  const navigate = useNavigate();
  const isHorizontal = variant === 'horizontal';

  const approvedCircles = getTribeDetails
    ? getTribeDetails
        .filter(
          (item) =>
            item.status === 'APPROVED' ||
            (item.status === 'ACTIVE' && item.join_status !== 'LEFT')
        )

        .sort((a, b) => {
          const roleOrder = { LEADER: 1, 'CO-LEADER': 2, MEMBER: 3 } as const;
          const aRole = a.role as keyof typeof roleOrder;
          const bRole = b.role as keyof typeof roleOrder;

          return (roleOrder[aRole] || 4) - (roleOrder[bRole] || 4);
        })
    : [];

  return (
    <div
      className={`${styles.container} ${isHorizontal ? styles.horizontal : ''}`}
    >
      <div className={styles.title}>Circles</div>

      {approvedCircles.length > 0 ? (
        <div className={styles.list}>
          {approvedCircles.map((item) => (
            <CircleItem
              item={item}
              key={item._id}
              selectedCircle={selectedCircle}
              setSelectedCircle={setSelectedCircle}
              variant={variant}
            />
          ))}
          {isHorizontal && (
            <button
              type="button"
              className={styles.addButton}
              onClick={() => navigate(PathRoutes.CreateCircleRoute)}
              aria-label="Create Circle"
            >
              <AddIcon />
            </button>
          )}
        </div>
      ) : isHorizontal ? (
        <button
          type="button"
          className={styles.addButton}
          onClick={() => navigate(PathRoutes.CreateCircleRoute)}
          aria-label="Create Circle"
        >
          <AddIcon />
        </button>
      ) : (
        <div className={styles.warning}>
          Your Circles will show up here when you are invited to a Circle or
          start one of your own.
        </div>
      )}
    </div>
  );
};
